import { z } from 'zod'
import { objectToCamel } from 'ts-case-convert'

//* ---------------- BASE ---------------- *//
const baseOptionGroupSchema = z.object({
  id: z.number(),
  name: z.string(),
  garment_type: z.number(),
  display_order: z.number(),
})

const baseOptionSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string(),
  display_order: z.number(),
  option_group_id: z.number(),
  option_group: baseOptionGroupSchema.optional(),
})

const baseOptionValueSchema = z.object({
  id: z.number(),
  option_value: z.string(),
  description: z.string().nullable(),
  image: z.string().nullable(),
  display_order: z.number(),
  has_image: z.boolean(),
})

//* ---------------- SCHEMAS ---------------- *//
export const optionGroupSchema = baseOptionGroupSchema.transform(objectToCamel)

export const manufacturerOptionValueSchema = z
  .object({
    id: z.number(),
    locale: z.union([z.literal('en'), z.literal('id'), z.literal('zh')]).nullable(),
    description: z.string().nullable(),
    chinese_description: z.string().nullable(),
  })
  .transform(objectToCamel)

export const optionSchema = baseOptionSchema
  .extend({
    garment_type: z.number(),
    location: z.string(),
    active: z.boolean(),
  })
  .transform(objectToCamel)

export const optionValueSchema = baseOptionValueSchema
  .extend({
    active: z.boolean(),
    garment_type: z.number(),
    default_value: z.boolean(),
    option: baseOptionSchema.transform(objectToCamel),
    manufacturer_option_values: z.array(manufacturerOptionValueSchema),
  })
  .transform(objectToCamel)

// Garment Options and Option Values
export const garmentOptionValueSchema = baseOptionValueSchema.transform(objectToCamel)
export const garmentOptionSchema = z
  .object({
    updated_at: z.coerce.date(),
    updated: z.boolean(),
    text: z.string().nullable(),
    option: baseOptionSchema,
    option_value: garmentOptionValueSchema.nullable(),
  })
  .transform(objectToCamel)

// TODO cts; 2026-06-25 We might want to avoid using Garment Properties. it is useful, though
// Garment Options via Garments Property is quite different from most other Options Schemas
export const garmentOptionPropertySchema = baseOptionSchema
  .omit({
    display_order: true,
    option_group_id: true,
    option_group: true,
  })
  .transform(objectToCamel)
export const garmentOptionValuePropertySchema = z
  .object({
    id: z.number(),
    value: z.string(),
    description: z.string().nullable(),
  })
  .transform(objectToCamel)

//* ---------------- TYPES ---------------- *//
declare global {
  namespace TrinityAPI {
    type OptionGroupType = z.infer<typeof optionGroupSchema>
    type ManufacturerOptionValueType = z.infer<typeof manufacturerOptionValueSchema>
    type OptionType = z.infer<typeof optionSchema>
    type OptionValueType = z.infer<typeof optionValueSchema>
    type GarmentOptionType = z.infer<typeof garmentOptionSchema>
    type GarmentOptionPropertyType = z.infer<typeof garmentOptionPropertySchema>
    type GarmentOptionValuePropertyType = z.infer<typeof garmentOptionValuePropertySchema>
  }
}
